import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { types } from 'store/user/types';
import { types as formTypes } from 'store/form/types';
import keycloak from 'Keycloak.js';

const EnterPage = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({ type: types.RESET_USER });
    dispatch({ type: formTypes.RESET_FORM });
    keycloak.tracker.invalidateUserForAuthPages(false, (data) => { 
      keycloak.tracker.installMonitorIdmSession(data, true);
      keycloak.redirectToHome();
     }); 
  }, []);
  return (
    <div className="enter-page">
    </div>
  );
};

export default EnterPage;
